(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Text = include('createjs.Text'),
		Delay = include('springroll.DelayedCall'),
		Container = include('createjs.Container');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class PrimalSpringrollTemplate.GamePanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var GamePanel = function()
	{
		BasePanel.call(this);

	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(GamePanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{

		this.skin = new lib.Game();

        //Cookie Monster talking animations/audio
		this.headAnimations = {
			"enter": {
				anim: "greeting",
				audio: "001_CM_Greeting"
			},
			"intro": [
				{
					anim: "instrux_1",
					audio: "002_CM_Instrux1"
				},
				{
					anim: "instrux_1a",
					audio: "026_CM_Instrux"
				}
			],
			"instrux": [
				{
					anim: "instrux_2",
					audio: "003_CM_Instrux2"
				},
				{
					anim: "instrux_alt1",
					audio: "004_CM_Instrux2_Alt1"
				},
				{
					anim: "instrux_alt2",
					audio: "005_CM_Instrux2_Alt2"
				}
			],
			"timeout": [
				{
					anim: "instrux_1a",
					audio: "026_CM_Instrux"
				},
				{
					anim: "timeout2",
					audio: "028_CM_Timeout2"
				},
				{
					anim: "timeout3",
					audio: "029_CM_Timeout3"
				}
			],
			"wrong": [
				{
					anim: "hint1",
					audio: "030_CM_Hint1"
				},
				{
					anim: "hint2",
					audio: "031_CM_Hint2"
				},
				{
					anim: "hint3",
					audio: "032_CM_Hint3"
				}
			],
			"payoff": [
				{
					anim: "sorry1",
					audio: "035_CM_Payoff3"
				},
				{
					anim: "sorry2",
					audio: "036_CM_Payoff_Alt1"
				},
				{
					anim: "sorry3",
					audio: "037_CM_Payoff_Alt2"
				},
				{
					anim: "sorry4",
					audio: "038_CM_Payoff_ALt3"
				}
			]	
		};

		this.headNames = ["talkingHeadClip", "talkingHeadClip2"];

		//Setup stage elements
		this.monster = this.skin.monster;
        this.monster.framerate = 12;
        this.monster.mc.head.framerate = 24;

        this.belt = this.skin.belt;
        this.belt.framerate = 24;

        this.bag = this.skin.bag;
        this.bag.framerate = 24;
        this.bag.gotoAndStop("empty");

        this.talkinghead = new lib.talkingHeadClip();
        this.talkinghead.headIndex = 0;
        this.talkinghead.framerate = 24;
        this.monster.mc.head.addChild(this.talkinghead);

        //Setup variables
        this.patterns = [[0, 1, 2], [0,1,1], [0,0,1]];
        this.currentPattern = [];
        this.patternIndex = 0;
        this.possibleFoods = [];
        this.beltPositions = [];
        this.options = [];
        this.shelfPositions = [];
        this.slots = [];
        this.answer = '';
        this.missingIndex = 8;
        this.initializeFoods();
        this.round = 0;

        //Start new round
        this.setPatternType();
        this.placeFood();
        this.placeOptions();

		this.addChild(this.skin);
	};

	//Initialize all possible foods and food positions on stage
	p.initializeFoods = function() {
		this.possibleFoods.push('watermelon');
		this.possibleFoods.push('sushi');
		this.possibleFoods.push('sandwich');
		this.possibleFoods.push('pretzel');
		this.possibleFoods.push('popcorn');
		this.possibleFoods.push('pizza');
		this.possibleFoods.push('pancakes');
		this.possibleFoods.push('jam');
		this.possibleFoods.push('icecream');
		this.possibleFoods.push('hotdog');
		this.possibleFoods.push('fish');
		this.possibleFoods.push('doughnut');
		this.possibleFoods.push('cupcake');
		this.possibleFoods.push('cheese');
		this.possibleFoods.push('carrot');
		this.possibleFoods.push('bread');
		this.possibleFoods.push('birthdaycake');
		this.possibleFoods.push('banana');
		this.possibleFoods.push('apple');

		this.beltPositions.push(this.belt.belt1);
		this.beltPositions.push(this.belt.belt2);
		this.beltPositions.push(this.belt.belt3);
		this.beltPositions.push(this.belt.belt4);
		this.beltPositions.push(this.belt.belt5);
		this.beltPositions.push(this.belt.belt6);
		this.beltPositions.push(this.belt.belt7);
		this.beltPositions.push(this.belt.belt8);
		this.beltPositions.push(this.belt.belt9);

		this.slots.push(this.belt.flash1);
		this.slots.push(this.belt.flash2);
		this.slots.push(this.belt.flash3);
		this.slots.push(this.belt.slot1);
		this.slots.push(this.belt.slot2);
		this.slots.push(this.belt.slot3);

		this.shelfPositions.push(this.skin.shelfpos0);
		this.shelfPositions.push(this.skin.shelfpos1);
		this.shelfPositions.push(this.skin.shelfpos2);
	};

	//Choose type of pattern to display
	p.setPatternType = function() {
		app.shuffle(this.possibleFoods);
		this.patternIndex = Math.floor(Math.random() * this.patterns.length);
		var pattern = this.patterns[this.patternIndex];
		for (var i = 0; i < pattern.length; i++) {
			var food = this.possibleFoods[pattern[i]];
			this.currentPattern.push(food);
		}
	};

	p.addChildAdjusted = function(parent, child, round) {
		parent.addChild(child);	
		parent.children[round].x -= child.nominalBounds.width/2;
		parent.children[round].y -= child.nominalBounds.height/2;
	};

	//Place the food onto the belt
	p.placeFood = function() {
		this.missingIndex = Math.floor(Math.random() * 3);
		for(var i=1;i<= this.beltPositions.length;i++){
			if (i-1 != this.missingIndex + 6) {
				var item = new lib[this.currentPattern[(i-1)%3]]();
				this.addChildAdjusted(this.beltPositions[i-1], item, this.round);	
			} else {
				this.answer = this.currentPattern[(i-1)%3];
			}
			this.beltPositions[i-1].answer = this.currentPattern[(i-1)%3];
		}
	};

	//Place the food options onto the shelf
	p.placeOptions = function() {
		this.options = this.currentPattern;
		for (var i = 0; i < this.options.length; i++) {
			var randomOption = Math.floor(Math.random() * this.possibleFoods.length);
			if (this.patternIndex !== 0 && i == 1) {
				this.options[i] = this.possibleFoods[randomOption];
			}
			var shelfItem = new lib[this.options[i]]();
			p.addChildAdjusted(this.shelfPositions[i], shelfItem, this.round);
			this.shelfPositions[i].answer = this.options[i];
		}
	};

	//Reset stage for each new round
	p.resetStage = function() {
		this.currentPattern = [];
		for (var i=0; i<= this.beltPositions.length-1;i++){
			this.beltPositions[i].removeChildAt(2);
		}
		for (var j=0; j<= this.shelfPositions.length-1;j++){
			this.shelfPositions[j].removeChildAt(2);
		}
		this.skin.bag.gotoAndStop("empty");
		this.setPatternType();
        this.placeFood();
        this.placeOptions();
	};

	//Play correct cookie monster body animation
	p.playCookieAnimation = function(anim, callback) {
		callback = callback || function(){};
		app.animator.stop(this.monster, true);

		var timeline = app.animator.play(this.monster, anim, callback);

	};

	//Play correct cookie monster head animation (for when he's talking)
	p.playHeadAnimation = function(anim, headIndex, callback) {
		callback = callback || function(){};
		headIndex = headIndex || 0;
		app.animator.stop(this.talkinghead, true);

		// had to split head into two symbols, so make sure to use the right one.
		if (this.talkinghead.headIndex !== headIndex) {
			this.monster.mc.head.removeChild(this.talkinghead);
			this.talkinghead = null;

			this.talkinghead = new lib[this.headNames[headIndex]]();
	        this.talkinghead.headIndex = headIndex;

	        this.talkinghead.framerate = 24;
	        this.monster.mc.head.addChild(this.talkinghead);
		}

		this.playCookieAnimation("talk");
		var timeline = app.animator.play(this.talkinghead, anim, callback);
	};

	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		s.teardown.call(this);
		this.skin = null;
	};

	//Assign to namespace
	namespace('PrimalSpringrollTemplate').GamePanel = GamePanel;
})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{});
var lib, images, createjs, ss;